module.exports = __webpack_public_path__ + "static/img/home_img_kjrk_sj.49a5b36.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home_img_kjrk_sj.png
// module id = lbp6
// module chunks = 11